import { errorToMessage } from '@/utils/errors';

type Translate = (key: string) => string;

// Firebase errors carry a `code` and no axios `response`, so errorToMessage alone
// returns null for them and the toast renders blank. Returns null when there is
// nothing to tell the customer.
export function socialLoginErrorMessage(error, t: Translate): string | null {
  switch (error.code) {
    // The customer closed the popup, or a second click replaced the first popup
    // request. Firebase carries on with the newest popup, so nothing has failed.
    case 'auth/popup-closed-by-user':
    case 'auth/cancelled-popup-request':
    case 'auth/user-cancelled':
      return null;
    case 'auth/account-exists-with-different-credential':
      return t('LOGIN.TEXT.WE_VE_GOT_AN_ACCOUNT_WITH_THIS');
    case 'auth/popup-blocked':
      return t('LOGIN.TEXT.SOCIAL_LOGIN_POPUP_BLOCKED');
    case 'auth/unauthorized-domain':
      return t('LOGIN.TEXT.SOCIAL_LOGIN_NOT_AVAILABLE_ON_THIS_SITE');
    default:
      console.error('Social login failed', error.code, error.message);
      return errorToMessage(error.response, t('LOGIN.TEXT.SOCIAL_LOGIN_FAILED'));
  }
}
